// components/Layout.js
import React from 'react';
import Header from '../common/Header';
import '../styles/LoginForm.css'; // Import the styles for the container

const Layout = ({ children }) => {
  return (
    <div className="login-page">
      <div className="logo-container">
        <Header />
      </div>
      <div className="login-container">
        <div className="login-card">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;